export const oktaConfig = {
    clientId: '0oacy5a601lu6HEwc5d7',
    issuer: 'https://dev-99845950.okta.com/oauth2/default',
    redirectUri: 'https://5picos.coimbra.escutismo.pt/login/callback',
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: true,
    useClassicEngine: true
}